<template>
    <div class="companies-view">
        <company-return-menu v-bind:ReturnMenuSettings="ReturnMenuSettings"/>
        <section class="companies-landing --disability-assist">
            <div class="dark-filter"></div>
            <div class="comp-logo"><router-link to="/home"><img width="150px" src="../assets/imgs/icons/global-choices-logo-white.png"> </router-link></div>
            <div class="intro-hd-container">
                <img src="../assets/imgs/icons/disability-assist-wheelchair.png">
                <img src="../assets/imgs/icons/disability-assist-logo-white.png">

                <p class="content-text --fl --prim">Global Choices Disability Assist (Pty) Ltd was established in 2012, as a Joint Venture between Global Choices Lifestyle (Pty) Ltd and the QuadPara Association of South Africa (QASA). This complementary combination of knowledge and expertise, together with our service provider networks, position us to deliver premium disability assistance and value-adding, disability-centric insurance products across the insurance sector. </p>
                <a href="http://www.disabilityassist.co.za/" target="_blank" rel="noopener noreferrer" class="btn comps-btn">GAIN PREMIUM ASSISTANCE</a>
            </div>

            <div class="social-icons-mobile">
                <ul class="social-items">
                    <li><a href="https://www.facebook.com/GlobalChoicesZA/" class="facebook" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://twitter.com/GlobalChoicesZA" class="twitter" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.linkedin.com/company/global-choices-lifestyle/?originalSubdomain=za" class="linkedin" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.instagram.com/globalchoicesza/" class="instagram" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.youtube.com/channel/UCbCW_LVHs3zhXqtY6yRETBQ" class="youtube" target="_blank" rel="noopener noreferrer"></a></li>
                </ul>
            </div>
            <SocialIconsMobile v-bind="SocialIconsMobileSettings" />
        </section>
    </div>
</template>

<script>
import CompanyReturnMenu from '@/components/ui/CompanyReturnMenu'
import SocialIconsMobile from '@/components/ui/SocialIconsMobile'

export default {
    components: { CompanyReturnMenu,SocialIconsMobile},
    data(){
        return {
            ReturnMenuSettings:{
                colorTheme:false
            },
            SocialIconsMobileSettings:{
                DarkIconsTrue:false
            }
        }
    } 
}
</script>

<style>

</style>
